import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsxs("g", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.0001 6c-.5523 0-1 .4477-1 1v10c0 .5523.4477 1 1 1h14c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1zm-3 1c0-1.6569 1.3431-3 3-3h14c1.6569 0 3 1.3431 3 3v10c0 1.6569-1.3431 3-3 3h-14c-1.6568 0-3-1.3431-3-3z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.168 6.4453c.3064-.4595.9273-.5837 1.3868-.2773l8.4453 5.6301 8.4453-5.6301c.4595-.3064 1.0804-.1822 1.3868.2773s.1821 1.0804-.2774 1.3868l-9 6a1 1 0 0 1-1.1094 0l-9-6c-.4595-.3064-.5837-.9273-.2773-1.3868"
            })
        ]
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "MailClose", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
